import React from 'react';
import SearchableSelect from '../../SearchableSelect';
import { MultiSelectFilterField } from '../types';

export type MultiSelectFieldProps = {
  field: MultiSelectFilterField;
  value: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
  /** Em popovers/modais, abre o menu em portal para não ficar atrás do rodapé */
  inOverlay?: boolean;
};

const MultiSelectField: React.FC<MultiSelectFieldProps> = ({
  field,
  value,
  onChange,
  disabled,
  inOverlay = false
}) => {
  return (
    <SearchableSelect
      multiple
      options={field.options}
      value={Array.isArray(value) ? value : []}
      onChange={onChange}
      placeholder={field.placeholder || 'Selecione'}
      loading={field.loading}
      disabled={disabled}
      fluid
      clearable={field.clearable !== false}
      openUpward={false}
      menuPortal={inOverlay}
    />
  );
};

export default MultiSelectField;
